<template>
  <footer class="bg-card border-t border-border mt-16">
    <div class="container mx-auto px-4 py-12">
      <div class="grid grid-cols-1 md:grid-cols-4 gap-8">
        <!-- Logo和介绍 -->
        <div class="col-span-1">
          <Logo />
          <p class="text-muted-foreground text-sm mt-4">
            专注QQ三国游戏交易服务，为玩家提供安全、便捷的担保交易平台。
          </p>
        </div>
        
        <!-- 关于我们 -->
        <div>
          <h4 class="mb-4">关于我们</h4>
          <ul class="space-y-2 text-sm text-muted-foreground">
            <li><router-link to="/platform-intro" class="hover:text-primary transition-colors">平台介绍</router-link></li>
            <li><router-link to="/contact" class="hover:text-primary transition-colors">联系我们</router-link></li>
            <li><router-link to="/join-us" class="hover:text-primary transition-colors">加入我们</router-link></li>
            <li><router-link to="/friend-links" class="hover:text-primary transition-colors">友情链接</router-link></li>
          </ul>
        </div>
        
        <!-- 帮助中心 -->
        <div>
          <h4 class="mb-4">帮助中心</h4>
          <ul class="space-y-2 text-sm text-muted-foreground">
            <li><router-link to="/guide/beginner" class="hover:text-primary transition-colors">新手指南</router-link></li>
            <li><router-link to="/trade-process" class="hover:text-primary transition-colors">交易流程</router-link></li>
            <li><router-link to="/faq" class="hover:text-primary transition-colors">常见问题</router-link></li>
            <li><router-link to="/guarantee" class="hover:text-primary transition-colors">担保说明</router-link></li>
          </ul>
        </div>
        
        <!-- 联系方式 -->
        <div>
          <h4 class="mb-4">联系方式</h4>
          <ul class="space-y-2 text-sm text-muted-foreground">
            <li>客服QQ：3169657770</li>
            <li>客服微信：13756905171</li>
            <li>客服电话：17767706635</li>
            <li>工作时间：9:30-24:00</li>
          </ul>
        </div>
      </div>
      
      <!-- 版权信息 -->
      <div class="border-t border-border mt-8 pt-8 text-center text-sm text-muted-foreground">
        <p>© 2026 甜甜QQ三国交易网 版权所有 | 吉ICP备2022000552号-1</p>
        <p class="mt-2">本平台提供担保交易服务，保障买卖双方权益</p>
      </div>
    </div>
  </footer>
</template>

<script>
import Logo from './Logo.vue'

export default {
  name: 'Footer',
  components: {
    Logo
  }
}
</script>
